import { LoaderContext } from "src/context/loaderContext";
import { useContext } from "react";

export const useLoading = () => useContext(LoaderContext);
